import { Component, Input } from '@angular/core';

@Component({
  selector: 'app-table-state',
  templateUrl: './table-state.component.html',
  styleUrls: ['./table-state.component.css'],
  host: { 'style': 'display: contents' } // ➜ integrates with parent table
})
export class TableStateComponent {
  @Input() loading: boolean = false;
  @Input() error: string | null = null;
  @Input() empty: boolean = false;

  @Input() rows: number = 10;
  @Input() columns: number = 5;

  get rowsArray() { return Array(this.rows).fill(0); }
  get colsArray() { return Array(this.columns).fill(0); }
}
